import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { DadosOcorrenciaPadrao, Ocorrencia } from "../../../../../../types/api/financeiro/detalhar-integracao-bancaria";
import moment from "moment";
import EditIcon from '@mui/icons-material/Edit';
import { useState } from "react";
import DialogIndicarTitulo from "./DialogIndicarTitulo.tsx/DialogIndicarTitulo";
import { formatarValorMonetario } from "../../../../../../helpers/masks";
import DataSemResultados from "../../../../../../components/DataSemResultados";
import { ModalDetalheTituloProvider } from "../../../MIContasReceber/ModalDetalheTituloContext";

export default function TableDadosEEVDandEEVC({
    tipo,
    rows,
    somenteVisualizacao,
    handleAlterarLinha
}: TableDadosEEVD_EEVCProps) {

    const [openModalTitulo, setOpenModalTitulo] = useState<IOpenModal | null>(null)

    return (
        <Box width='100%'>
            <TableContainer sx={{ maxHeight: "74vh" }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            <TableCell><b>Data</b></TableCell>
                            <TableCell sx={{ minWidth: 122 }} align="right"><b>Qtd parcelas</b></TableCell>
                            <TableCell align="right"><b>Valor bruto</b></TableCell>
                            <TableCell sx={{ minWidth: 100 }} align="right"><b>Valor taxa</b></TableCell>
                            <TableCell align="right"><b>Autorização</b></TableCell>
                            <TableCell><b>Resposta</b></TableCell>
                            <TableCell><b>Status</b></TableCell>
                            <TableCell><b>Titulo</b></TableCell>
                            <TableCell sx={{ minWidth: 142 }} align="right"><b>Resumo vendas</b></TableCell>
                            <TableCell align="right"><b>Estabelecimento</b></TableCell>
                            {!somenteVisualizacao && <TableCell></TableCell>}
                        </TableRow>
                    </TableHead>

                    {
                        rows.length > 0 &&
                        <TableBody>
                            {rows.map((row) => {
                                const tituloResposta = row.resumo_dados.resposta
                                const status = row.status
                                const permitirEditar = row.resumo_dados.titulos_possiveis.length > 0
                                 const resumo = row.resumo_dados as DadosOcorrenciaPadrao

                                let colorBg = ''
                                if (status === "Aguardando finalização") colorBg = "#e5f6fd"
                                if (status === "Conflito encontrado") colorBg = "#fff9e6"
                                if (status === "Finalizado") colorBg = "#e5fde5"

                                let colorTitulo = 'info'
                                if (
                                    tituloResposta === "Múltiplos títulos encontrados pelo NSU" ||
                                    tituloResposta === "Múltiplos títulos encontrados pela data de emissão e valor"
                                ) colorTitulo = "#ef7918"

                                if (
                                    tituloResposta === "Título encontrado pelo NSU" ||
                                    tituloResposta === "Título encontrado pela data de emissão e valor" ||
                                    tituloResposta === "Título selecionado manualmente"
                                ) colorTitulo = "primary"

                                if (tituloResposta === "Título não encontrado") colorTitulo = "error"

                                return (
                                    <TableRow
                                        key={row.id}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 }, backgroundColor: colorBg }}
                                    >
                                        <TableCell>{moment(row.resumo_dados.data).format("DD/MM/YYYY")}</TableCell>
                                        <TableCell align="right">{row.resumo_dados.qtd_parcelas}</TableCell>
                                        <TableCell align="right">{formatarValorMonetario(row.resumo_dados.valor)}</TableCell>
                                        <TableCell align="right">{formatarValorMonetario(row.resumo_dados.valor_taxa)}</TableCell>
                                        <TableCell align="right">{row.resumo_dados.nsu || "-"}</TableCell>
                                        <TableCell >
                                            <Typography variant="subtitle2" color={colorTitulo}>
                                                {row.resumo_dados.resposta}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>{row.status}</TableCell>
                                        <TableCell >
                                            <Typography variant="subtitle2" color={colorTitulo} >
                                                 {row.resumo_dados.titulo ? 
                                                    (typeof row.resumo_dados.titulo === 'string' && 
                                                     (row.resumo_dados.titulo.startsWith('[') || row.resumo_dados.titulo.includes('"')) ? 
                                                        row.resumo_dados.titulo.replace(/[\[\]"\\]/g, '') : 
                                                        row.resumo_dados.titulo) 
                                                    : "-"}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="right">{row.resumo_dados.resumo_vendas}</TableCell>
                                        <TableCell align="right">{row.resumo_dados.estabelecimento}</TableCell>
                                        {
                                            !somenteVisualizacao &&
                                            <TableCell align="right">
                                                {
                                                    status !== "Finalizado" &&
                                                    <IconButton
                                                        size="small"
                                                        aria-label="delete"
                                                        disabled={!permitirEditar}
                                                        onClick={() => setOpenModalTitulo({
                                                            idRow: row.id,
                                                            titulo: row.resumo_dados.titulo,
                                                            titulos_possiveis: resumo.titulos_possiveis
                                                        })}
                                                    >
                                                        <EditIcon fontSize="inherit" />
                                                    </IconButton>
                                                }
                                            </TableCell>
                                        }
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    }
                    {
                        rows.length === 0 &&
                        <TableBody>
                            <TableRow>
                                <TableCell colSpan={10} align="center">
                                    <DataSemResultados size="medium" texto="Nenhum resultado encontrado" />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    }
                </Table>
            </TableContainer>

            {
                openModalTitulo &&
                <ModalDetalheTituloProvider>
                    <DialogIndicarTitulo
                        {...{ tipo }}
                        open={Boolean(openModalTitulo.idRow)}
                        titulo={openModalTitulo.titulo}
                        opcoes={openModalTitulo.titulos_possiveis}
                        handleClose={() => setOpenModalTitulo(null)}
                        handleSubmit={(titulo) => handleAlterarLinha(openModalTitulo.idRow, titulo)}
                    />
                </ModalDetalheTituloProvider>
            }
        </Box>
    )
}

interface TableDadosEEVD_EEVCProps {
    tipo: string;
    rows: Ocorrencia[],
    somenteVisualizacao: boolean,
    handleAlterarLinha: (id: number, titulo: string) => void
}

interface IOpenModal {
    idRow: number;
    titulo: string | null,
    titulos_possiveis: string[]
}